<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure><i class="icon icon-icon_tags"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                product types <i class="icon icon-icon_arrow-right"></i> importation
                            </span>
                            <h1>Importation</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="upload($event)" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <div>

                        <input class="input" type="file" id="import" @change="simulate($event)" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv">

                        <div class="tree-readonly" v-if="dataToShow.children">
                            <ul>
                                <li v-for="item in dataToShow.children">
                                    <span class="name">{{item.name}}</span>
                                    <ul v-if="item.attributes">
                                        <li v-for="value in item.attributes">
                                            <span class="name">-> #{{value.id}} {{value.ref}}</span>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                    </div>

                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import Service from './ProductTypeService.js';
    import Import from '../../../layouts/Import.vue';

    export default {
        extends: Import,
        data () {
            return {
                test: null,
                options: [],
                dataToShow: {
                    name: 'root',
                    children: []
                }
            }
        },
        mounted: function(){
            this.initialize()
        },
        methods:{
            upload(e){
                let fileInput = document.getElementById( 'import' );
                let data = new FormData();
                data.append( 'file', fileInput.files[0] );
                data.append( 'save', true );
                Service.import(data).then((response) => {
                    this.dataToShow.children = response.data
                    this.$emit("refresh", this)
                    this.back()
                })
            },
            simulate(e){
                let fileInput = document.getElementById( 'import' );
                let data = new FormData();
                data.append( 'file', fileInput.files[0] );
                Service.import(data).then((response) => {
                    this.dataToShow.children = response.data
                })
            },
            getResource: function(){
                return Service
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/type/Import.vue